import { Box, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import DarkLogo from "../../img/icons/dark_logo.svg";
import LightLogo from "../../img/icons/logo.svg";

export default function LogoWidget() {
    const { mode } = useColorScheme();
    return (
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Box
            sx={{
                width: "2rem",
                height: "2rem",
                borderRadius: "calc(0.5rem - 2px)",
                backgroundColor: mode ? Constants.Colors[mode].sidebarPrimary : Constants.Colors.light.sidebarPrimary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <img src={mode === "dark" ? DarkLogo : LightLogo} alt="Logo" style={{ 
                width: "1.0rem", 
                height: "1.0rem",
                }} 
            />
        </Box>
        <Typography sx={{ fontSize: "1.125rem", fontWeight: "600", }}>Redirect Mapper</Typography>
        </Stack>
    );
}